import api from '@/config/api';
import { AdminUser, InviteAdminRequest, AdminActivity } from '@/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5004/api';

export const adminService = {
   // Invite new admin member
   async inviteMember(data: InviteAdminRequest): Promise<AdminUser> {
      const response = await api.post(`${API_URL}/admin/invite-member`, data);
      return response.data.data;
   },

   // Get all admin members
   async getMembers(): Promise<{ members: AdminUser[]; total: number }> {
      const response = await api.get(`${API_URL}/admin/members`);
      return response.data.data;
   },

   // Resend invitation to admin member
   async resendInvitation(userId: string): Promise<void> {
      await api.post(`${API_URL}/admin/resend-invitation/${userId}`);
   },

   // Remove admin member
   async removeMember(userId: string): Promise<void> {
      await api.delete(`${API_URL}/admin/members/${userId}`);
   },

   // Change admin member role
   async changeRole(userId: string, role: 'admin' | 'super admin'): Promise<void> {
      await api.put(`${API_URL}/admin/members/${userId}/role`, { role });
   },

   // Get admin activities (audit log)
   async getActivities(params?: { limit?: number; page?: number }): Promise<{
      activities: AdminActivity[];
      page: number;
      limit: number;
      total: number;
   }> {
      const response = await api.get(`${API_URL}/admin/activities`, { params });
      return response.data.data;
   },
};
